import {
  Smartphone, Sparkles, Cable, Plug, ShieldCheck, Boxes, Headphones, TrendingUp,
} from "lucide-react";
import SectionHeading from "./SectionHeading";
import { useI18n } from "@/i18n";

const ICONS = [Smartphone, Sparkles, Cable, Plug, ShieldCheck, Boxes, Headphones, TrendingUp];

export default function Products() {
  const { t } = useI18n();
  const cards = t("products.cards") || [];
  return (
    <section id="products" data-testid="products-section" className="relative py-24 md:py-32 noise">
      <div className="glow-blue" style={{ width: 700, height: 360, left: "50%", top: -80, transform: "translateX(-50%)", background: "radial-gradient(ellipse at center, rgba(122,92,255,0.25), transparent 60%)" }} />
      <div className="relative max-w-7xl mx-auto px-6 md:px-10">
        <SectionHeading
          testId="products-heading"
          eyebrow={t("products.eyebrow")}
          title={<>
            {t("products.title_a")}{" "}
            <span className="text-gradient-brand">{t("products.title_b")}</span>
            {t("products.title_dot")}
          </>}
          subtitle={t("products.subtitle")}
          align="center"
        />
        <div className="mt-14 grid grid-cols-1 sm:grid-cols-2 lg:grid-cols-4 gap-4 md:gap-5">
          {cards.map((card, i) => {
            const Icon = ICONS[i] || Smartphone;
            return (
              <article
                key={i}
                data-testid={`product-card-${i}`}
                className="glass-card rounded-2xl p-6 reveal relative group overflow-hidden"
                style={{ transitionDelay: `${(i % 4) * 70}ms` }}
              >
                <div className="absolute -inset-[1px] rounded-2xl opacity-0 group-hover:opacity-100 transition-opacity duration-500 pointer-events-none" style={{ background: "radial-gradient(60% 40% at 50% 0%, rgba(22,75,255,0.18), transparent 70%)" }} />
                <div className="icon-bubble mb-5"><Icon className="w-5 h-5" /></div>
                <h3 className="font-display text-[16.5px] font-semibold tracking-tight text-white">{card.title}</h3>
                <p className="mt-2 text-[13.5px] text-[#A8A8B3] leading-relaxed">{card.body}</p>
              </article>
            );
          })}
        </div>
      </div>
    </section>
  );
}
